import React from 'react';
import { Box, FormControl, Select, MenuItem, Typography, Button } from '@mui/material';

export default function DocumentUploadBox({ 
    documentType, 
    onDocumentTypeChange, 
    onFileChange, 
    selectedFile, 
    onUpload 
}) {
    return (
        <Box sx={{ width: 220, textAlign: 'center',border:"1px solid black",p:3,borderRadius:"6px" }}>
            <FormControl fullWidth sx={{ mb: 2 }}>
                <Select
                    displayEmpty
                    value={documentType || ''}
                    onChange={onDocumentTypeChange}
                    sx={{ height: 40 }}
                >
                    <MenuItem value="" disabled>Select Document Type</MenuItem>
                    <MenuItem value="photo_id">Photo ID</MenuItem>
                    <MenuItem value="driving_license">Driving License</MenuItem>
                    <MenuItem value="address_proof">Address Proof</MenuItem>
                </Select>
            </FormControl>

            <Box
                sx={{
                    width: '100%',
                    height: 200,
                    border: '2px dashed #ccc',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                    cursor: 'pointer',
                    '&:hover': { borderColor: '#aaa' }
                }}
                onClick={() => document.getElementById(`file-upload-${documentType}`).click()}
            >
                <input
                    type="file"
                    id={`file-upload-${documentType}`}
                    style={{ display: 'none' }}
                    onChange={onFileChange}
                />
                {selectedFile ? (
                    <Typography>{selectedFile.name}</Typography>
                ) : (
                    <Box sx={{ textAlign: 'center' }}>
                        <Typography sx={{ mt: 1, color: '#666' }}>Click to browse files</Typography>
                    </Box>
                )}
            </Box>

            <Button
                variant="contained"
                fullWidth
                onClick={onUpload}
                disabled={!documentType || !selectedFile}
                sx={{
                    backgroundColor: '#1976d2',
                    color: 'white',
                    '&:hover': { backgroundColor: '#1565c0' }
                }}
            >
                Upload
            </Button>
        </Box>
    );
}